var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7206 3.74889C23.3272 3.34005 22.6728 3.34005 22.2794 3.74889L15.9692 10.3067C15.3579 10.942 15.8081 12 16.6898 12H20V20H12V16.6898C12 15.8082 10.9419 15.3579 10.3066 15.9692L3.74885 22.2795C3.34002 22.6729 3.34002 23.3272 3.74886 23.7206L10.3066 30.0308C10.9419 30.6422 12 30.1919 12 29.3103V26H20V34H16.6898C15.8081 34 15.3579 35.0581 15.9692 35.6934L22.2794 42.2512C22.6728 42.66 23.3272 42.66 23.7206 42.2512L30.0308 35.6934C30.6421 35.0581 30.1919 34 29.3102 34H26V26H34V29.3103C34 30.1919 35.0581 30.6422 35.6934 30.0308L42.2512 23.7206C42.66 23.3272 42.66 22.6729 42.2512 22.2795L35.6934 15.9692C35.0581 15.3579 34 15.8082 34 16.6898V20H26V12H29.3102C30.1919 12 30.6421 10.942 30.0308 10.3067L23.7206 3.74889Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/Move.4fc45da90d900cf7f24a51d16f44295e.svg";
export { ForwardRef as ReactComponent };